import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
import { getIconByName } from '../../../utils/iconMap';
/**
 * InfoCard – icon + title + description card. Supports label + gradient.
 */
const InfoCard = ({ label, gradient, title, description, icon = 'Info', iconSize = 64, iconColor, iconBackground, titleColor, titleFontSize, descriptionColor, descriptionFontSize, accentColor, padding = 3, paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, width, borderRadius = 2, border, borderColor, backgroundColor, boxShadow, fontFamily, fontWeight = 700, componentAlignment = 'left', }) => {
    const theme = useTheme();
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : backgroundColor || 'transparent';
    const IconComponent = getIconByName(icon);
    const accent = accentColor || theme.palette.primary.main;
    const iconBg = iconBackground || (iconColor ? alpha(iconColor, 0.1) : alpha(accent, 0.1));
    const iconCol = iconColor || accent;
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 400, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsxs(Box, { sx: {
                        p: padding,
                        pt: paddingTop,
                        pr: paddingRight,
                        pb: paddingBottom,
                        pl: paddingLeft,
                        borderRadius: typeof borderRadius === 'number' ? borderRadius : borderRadius,
                        border: border || `2px solid ${alpha(accent, 0.2)}`,
                        borderColor: borderColor || alpha(accent, 0.2),
                        bgcolor: backgroundColor || alpha(accent, 0.04),
                        width: width || '100%',
                        boxShadow: boxShadow || '0 1px 3px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            bgcolor: backgroundColor ? alpha(backgroundColor, 0.95) : alpha(accent, 0.08),
                            borderColor: alpha(accent, 0.4),
                            boxShadow: boxShadow || `0 8px 24px ${alpha(accent, 0.15)}`,
                        },
                    }, children: [_jsx(Box, { sx: {
                                width: typeof iconSize === 'number' ? iconSize : 64,
                                height: typeof iconSize === 'number' ? iconSize : 64,
                                borderRadius: 1,
                                bgcolor: iconBg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 2,
                            }, children: _jsx(IconComponent, { sx: { fontSize: (typeof iconSize === 'number' ? iconSize : 64) / 2, color: iconCol } }) }), _jsx(Typography, { variant: "h6", sx: {
                                fontWeight: Number(fontWeight) || 700,
                                fontSize: titleFontSize,
                                fontFamily: fontFamily || undefined,
                                mb: 1.5,
                                color: titleColor || 'text.primary',
                            }, children: title }), description && (_jsx(Typography, { variant: "body2", sx: {
                                lineHeight: 1.8,
                                fontSize: descriptionFontSize,
                                fontFamily: fontFamily || undefined,
                                color: descriptionColor || 'text.secondary',
                            }, children: description }))] })] }) }));
};
export default InfoCard;
